import axios from 'actions/video-obs/axiosConfig';

import {
  GetDoubleCoderScoresResponse,
  UpdateDoubleCoderScoresRequestParams
} from './types';

// GET /api/v1/video_uploads/:video_upload_id/double_coder_scores
export function getDoubleCoderScores(videoUploadId: number) {
  return axios.get<GetDoubleCoderScoresResponse>(
    `/api/v1/video_uploads/${videoUploadId}/double_coder_scores`
  );
}

// PUT /api/v1/video_uploads/:video_upload_id/double_coder_scores
export function updateDoubleCoderScores(
  videoUploadId: number,
  params: UpdateDoubleCoderScoresRequestParams
) {
  return axios.put(
    `/api/v1/video_uploads/${videoUploadId}/double_coder_scores`,
    params
  );
}

// POST /api/v1/video_uploads/:video_upload_id/double_coder_scores/complete
export function completeDoubleCoderScores(videoUploadId: number) {
  return axios.post(
    `/api/v1/video_uploads/${videoUploadId}/double_coder_scores/complete`
  );
}
